var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAudit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.167969 8.09131L0.167969 2.72751C0.167969 1.74006 0.968454 0.939578 1.9559 0.939578L22.5171 0.939578C23.5046 0.939578 24.3051 1.74006 24.3051 2.72751V8.09131L0.167969 8.09131Z",
    fill: "#044D9F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.32031 24.1826H1.95651C0.969066 24.1826 0.168582 23.3821 0.168582 22.3947V9.87916H7.32031V24.1826Z",
    fill: "#044D9F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.10742 24.1826H22.5169C23.5044 24.1826 24.3048 23.3821 24.3048 22.3947V9.87916H9.10742V24.1826Z",
    fill: "#5487C1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAudit);
export default __webpack_public_path__ + "static/media/audit.4ad9f4d73244b153da0cd88bf19906fe.svg";
export { ForwardRef as ReactComponent };